// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* FAQ Search Styles */
.faq-search {
  position: relative;
  max-width: 800px;
  margin: 0 auto;
}

.search-form {
  display: flex;
  gap: 1rem;
  align-items: center;
  background: var(--bg-primary);
  border-radius: 16px;
  box-shadow: 0 4px 20px var(--shadow-primary);
  padding: 0.5rem;
  border: 2px solid var(--border-primary);
  transition: all 0.3s ease;
}

.search-form:focus-within {
  border-color: var(--accent-primary);
  box-shadow: 0 4px 20px rgba(59, 130, 246, 0.15);
}

.search-input-container {
  flex: 1;
  position: relative;
  display: flex;
  align-items: center;
}

.search-icon {
  position: absolute;
  left: 1rem;
  font-size: 1.2rem;
  color: var(--text-secondary);
  z-index: 2;
}

.search-spinner {
  font-size: 1.2rem;
  color: var(--accent-primary);
}

.search-input {
  width: 100%;
  padding: 1rem 1rem 1rem 3rem;
  border: none;
  outline: none;
  font-size: 1rem;
  background: transparent;
  color: var(--text-primary);
}

.search-input::placeholder {
  color: var(--text-tertiary);
}

.clear-button {
  position: absolute;
  right: 1rem;
  background: var(--bg-secondary);
  border: none;
  border-radius: 50%;
  width: 2rem;
  height: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: var(--text-secondary);
  font-size: 0.8rem;
  transition: all 0.3s ease;
}

.clear-button:hover {
  background: var(--bg-tertiary);
  color: var(--text-primary);
}

.search-button {
  background: linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%);
  color: white;
  border: none;
  padding: 1rem 2rem;
  border-radius: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;
}

.search-button:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 4px 20px rgba(59, 130, 246, 0.3);
}

.search-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Search Suggestions */
.search-suggestions {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: var(--bg-primary);
  border: 2px solid var(--border-primary);
  border-top: none;
  border-radius: 0 0 16px 16px;
  box-shadow: 0 4px 20px var(--shadow-primary);
  z-index: 1000;
  max-height: 400px;
  overflow-y: auto;
}

.suggestions-header {
  padding: 1rem 1.5rem 0.5rem;
  border-bottom: 1px solid var(--border-primary);
}

.suggestions-title {
  font-size: 0.9rem;
  font-weight: 600;
  color: var(--text-secondary);
  margin: 0;
}

.suggestions-list {
  padding: 0.5rem 0;
}

.suggestion-item {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem 1.5rem;
  background: none;
  border: none;
  text-align: left;
  cursor: pointer;
  transition: all 0.3s ease;
  color: var(--text-primary);
  font-size: 0.95rem;
}

.suggestion-item:hover {
  background: var(--bg-secondary);
  color: var(--accent-primary);
}

.suggestion-icon {
  font-size: 1rem;
  opacity: 0.7;
}

.suggestion-text {
  flex: 1;
}

/* Search Tips */
.search-tips {
  margin-top: 2rem;
  background: var(--bg-primary);
  border-radius: 16px;
  padding: 2rem;
  box-shadow: 0 4px 20px var(--shadow-primary);
}

.tips-header {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 1.5rem;
}

.tips-icon {
  font-size: 1.5rem;
}

.tips-title {
  font-size: 1.2rem;
  font-weight: 600;
  color: var(--text-primary);
  margin: 0;
}

.tips-list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.tip-item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem;
  background: var(--bg-secondary);
  border-radius: 8px;
  border-left: 4px solid var(--accent-primary);
}

.tip-icon {
  font-size: 1.2rem;
  opacity: 0.8;
}

.tip-text {
  color: var(--text-primary);
  font-size: 0.95rem;
  line-height: 1.5;
  font-weight: 500;
}

/* Responsive Design */
@media (max-width: 768px) {
  .search-form {
    flex-direction: column;
    gap: 0.75rem;
  }
  
  .search-input-container {
    width: 100%;
  }
  
  .search-button {
    width: 100%;
    padding: 0.875rem 1.5rem;
  }
  
  .search-suggestions {
    position: relative;
    top: 0;
    border-radius: 16px;
    margin-top: 0.5rem;
  }
  
  .search-tips {
    padding: 1.5rem;
  }
  
  .tips-list {
    gap: 0.75rem;
  }
  
  .tip-item {
    padding: 0.5rem;
  }
}

@media (max-width: 480px) {
  .search-input {
    padding: 0.875rem 0.875rem 0.875rem 2.5rem;
    font-size: 0.95rem;
  }
  
  .search-icon {
    left: 0.75rem;
    font-size: 1rem;
  }
  
  .clear-button {
    right: 0.75rem;
    width: 1.75rem;
    height: 1.75rem;
  }
  
  .suggestion-item {
    padding: 0.6rem 1rem;
    font-size: 0.9rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/faq/search/FAQSearch.css"],"names":[],"mappings":"AAAA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,6BAA6B;EAC7B,mBAAmB;EACnB,4CAA4C;EAC5C,eAAe;EACf,uCAAuC;EACvC,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;EACnC,+CAA+C;AACjD;;AAEA;EACE,OAAO;EACP,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,iBAAiB;EACjB,4BAA4B;EAC5B,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,YAAY;EACZ,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,+BAA+B;EAC/B,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,4BAA4B;EAC5B,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,6BAA6B;EAC7B,uCAAuC;EACvC,gBAAgB;EAChB,4BAA4B;EAC5B,4CAA4C;EAC5C,aAAa;EACb,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,4BAA4B;EAC5B,SAAS;AACX;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,OAAO;AACT;;AAEA,gBAAgB;AAChB;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;EACnB,aAAa;EACb,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,+BAA+B;EAC/B,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,wBAAwB;EAC1B;;EAEA;IACE,kBAAkB;IAClB,MAAM;IACN,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,0CAA0C;IAC1C,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,oBAAoB;IACpB,iBAAiB;EACnB;AACF","sourcesContent":["/* FAQ Search Styles */\r\n.faq-search {\r\n  position: relative;\r\n  max-width: 800px;\r\n  margin: 0 auto;\r\n}\r\n\r\n.search-form {\r\n  display: flex;\r\n  gap: 1rem;\r\n  align-items: center;\r\n  background: var(--bg-primary);\r\n  border-radius: 16px;\r\n  box-shadow: 0 4px 20px var(--shadow-primary);\r\n  padding: 0.5rem;\r\n  border: 2px solid var(--border-primary);\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n.search-form:focus-within {\r\n  border-color: var(--accent-primary);\r\n  box-shadow: 0 4px 20px rgba(59, 130, 246, 0.15);\r\n}\r\n\r\n.search-input-container {\r\n  flex: 1;\r\n  position: relative;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.search-icon {\r\n  position: absolute;\r\n  left: 1rem;\r\n  font-size: 1.2rem;\r\n  color: var(--text-secondary);\r\n  z-index: 2;\r\n}\r\n\r\n.search-spinner {\r\n  font-size: 1.2rem;\r\n  color: var(--accent-primary);\r\n}\r\n\r\n.search-input {\r\n  width: 100%;\r\n  padding: 1rem 1rem 1rem 3rem;\r\n  border: none;\r\n  outline: none;\r\n  font-size: 1rem;\r\n  background: transparent;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.search-input::placeholder {\r\n  color: var(--text-tertiary);\r\n}\r\n\r\n.clear-button {\r\n  position: absolute;\r\n  right: 1rem;\r\n  background: var(--bg-secondary);\r\n  border: none;\r\n  border-radius: 50%;\r\n  width: 2rem;\r\n  height: 2rem;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  cursor: pointer;\r\n  color: var(--text-secondary);\r\n  font-size: 0.8rem;\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n.clear-button:hover {\r\n  background: var(--bg-tertiary);\r\n  color: var(--text-primary);\r\n}\r\n\r\n.search-button {\r\n  background: linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%);\r\n  color: white;\r\n  border: none;\r\n  padding: 1rem 2rem;\r\n  border-radius: 12px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: all 0.3s ease;\r\n  white-space: nowrap;\r\n}\r\n\r\n.search-button:hover:not(:disabled) {\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 4px 20px rgba(59, 130, 246, 0.3);\r\n}\r\n\r\n.search-button:disabled {\r\n  opacity: 0.5;\r\n  cursor: not-allowed;\r\n}\r\n\r\n/* Search Suggestions */\r\n.search-suggestions {\r\n  position: absolute;\r\n  top: 100%;\r\n  left: 0;\r\n  right: 0;\r\n  background: var(--bg-primary);\r\n  border: 2px solid var(--border-primary);\r\n  border-top: none;\r\n  border-radius: 0 0 16px 16px;\r\n  box-shadow: 0 4px 20px var(--shadow-primary);\r\n  z-index: 1000;\r\n  max-height: 400px;\r\n  overflow-y: auto;\r\n}\r\n\r\n.suggestions-header {\r\n  padding: 1rem 1.5rem 0.5rem;\r\n  border-bottom: 1px solid var(--border-primary);\r\n}\r\n\r\n.suggestions-title {\r\n  font-size: 0.9rem;\r\n  font-weight: 600;\r\n  color: var(--text-secondary);\r\n  margin: 0;\r\n}\r\n\r\n.suggestions-list {\r\n  padding: 0.5rem 0;\r\n}\r\n\r\n.suggestion-item {\r\n  width: 100%;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.75rem;\r\n  padding: 0.75rem 1.5rem;\r\n  background: none;\r\n  border: none;\r\n  text-align: left;\r\n  cursor: pointer;\r\n  transition: all 0.3s ease;\r\n  color: var(--text-primary);\r\n  font-size: 0.95rem;\r\n}\r\n\r\n.suggestion-item:hover {\r\n  background: var(--bg-secondary);\r\n  color: var(--accent-primary);\r\n}\r\n\r\n.suggestion-icon {\r\n  font-size: 1rem;\r\n  opacity: 0.7;\r\n}\r\n\r\n.suggestion-text {\r\n  flex: 1;\r\n}\r\n\r\n/* Search Tips */\r\n.search-tips {\r\n  margin-top: 2rem;\r\n  background: var(--bg-primary);\r\n  border-radius: 16px;\r\n  padding: 2rem;\r\n  box-shadow: 0 4px 20px var(--shadow-primary);\r\n}\r\n\r\n.tips-header {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.75rem;\r\n  margin-bottom: 1.5rem;\r\n}\r\n\r\n.tips-icon {\r\n  font-size: 1.5rem;\r\n}\r\n\r\n.tips-title {\r\n  font-size: 1.2rem;\r\n  font-weight: 600;\r\n  color: var(--text-primary);\r\n  margin: 0;\r\n}\r\n\r\n.tips-list {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 1rem;\r\n}\r\n\r\n.tip-item {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.75rem;\r\n  padding: 0.75rem;\r\n  background: var(--bg-secondary);\r\n  border-radius: 8px;\r\n  border-left: 4px solid var(--accent-primary);\r\n}\r\n\r\n.tip-icon {\r\n  font-size: 1.2rem;\r\n  opacity: 0.8;\r\n}\r\n\r\n.tip-text {\r\n  color: var(--text-primary);\r\n  font-size: 0.95rem;\r\n  line-height: 1.5;\r\n  font-weight: 500;\r\n}\r\n\r\n/* Responsive Design */\r\n@media (max-width: 768px) {\r\n  .search-form {\r\n    flex-direction: column;\r\n    gap: 0.75rem;\r\n  }\r\n  \r\n  .search-input-container {\r\n    width: 100%;\r\n  }\r\n  \r\n  .search-button {\r\n    width: 100%;\r\n    padding: 0.875rem 1.5rem;\r\n  }\r\n  \r\n  .search-suggestions {\r\n    position: relative;\r\n    top: 0;\r\n    border-radius: 16px;\r\n    margin-top: 0.5rem;\r\n  }\r\n  \r\n  .search-tips {\r\n    padding: 1.5rem;\r\n  }\r\n  \r\n  .tips-list {\r\n    gap: 0.75rem;\r\n  }\r\n  \r\n  .tip-item {\r\n    padding: 0.5rem;\r\n  }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .search-input {\r\n    padding: 0.875rem 0.875rem 0.875rem 2.5rem;\r\n    font-size: 0.95rem;\r\n  }\r\n  \r\n  .search-icon {\r\n    left: 0.75rem;\r\n    font-size: 1rem;\r\n  }\r\n  \r\n  .clear-button {\r\n    right: 0.75rem;\r\n    width: 1.75rem;\r\n    height: 1.75rem;\r\n  }\r\n  \r\n  .suggestion-item {\r\n    padding: 0.6rem 1rem;\r\n    font-size: 0.9rem;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
